export function ArrowRightRight() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.27939 13.2086C8.579 13.4226 8.99536 13.3532 9.20937 13.0536L12.5427 8.38689C12.7083 8.15509 12.7083 7.84371 12.5427 7.61191L9.20937 2.94524C8.99536 2.64563 8.579 2.57624 8.27939 2.79025C7.97978 3.00425 7.91039 3.42062 8.12439 3.72023L11.1809 7.9994L8.12439 12.2786C7.91039 12.5782 7.97978 12.9945 8.27939 13.2086Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.61272 13.2086C3.91233 13.4226 4.3287 13.3532 4.5427 13.0536L7.87604 8.38689C8.04161 8.15509 8.04161 7.84371 7.87604 7.61191L4.5427 2.94524C4.3287 2.64563 3.91233 2.57624 3.61272 2.79025C3.31311 3.00425 3.24372 3.42062 3.45773 3.72023L6.51428 7.9994L3.45773 12.2786C3.24372 12.5782 3.31311 12.9945 3.61272 13.2086Z"
        fill="currentColor"
      />
    </svg>
  );
}
